export default __webpack_public_path__ + "static/media/thumbnail.13499bf1.png";